import axios from "axios";
const API_URL = "https://content.blairadventures.com/public/_";
const API_URL_AUTH = `${API_URL}/auth/authenticate`;

const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: false
});

export default {
  getAdventures() {
    return apiClient.get("/items/adventures");
  },
  addAdventure(adventure, token) {
    return axios({
      method: "post",
      url: `${API_URL}/items/adventures`,
      data: {
        title: adventure.title,
        slug: adventure.slug,
        author: adventure.author
      },
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  },
  getFamily() {
    return apiClient.get("/items/family");
  },
  getAllAlbums() {
    return apiClient.get("/files?filter[metadata][nempty]");
  },
  getImagesForAlbum(albumTitle) {
    return apiClient.get(`/files?filter[metadata][contains]=${albumTitle}`);
  },
  getAccessToken(email, password) {
    return axios({
      method: "post",
      url: API_URL_AUTH,
      data: {
        email: email,
        password: password
      }
    });
  },
  getUser(token) {
    return apiClient.get("/users/me?fields=*.*", {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  },
  getUserRole(token, roleId) {
    return apiClient.get(`/roles/${roleId}`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  },
  getAllUserPermissions(token, collectionName) {
    return apiClient.get(`/permissions/me/${collectionName}`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  },
  getUserPermissionsForCollection(token, collectionName) {
    return apiClient.get(`/permissions/me/${collectionName}`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }
};
